import { Link } from 'react-router-dom';

export default function IndustriesSection() {
  const industries = [
    { icon: 'ri-briefcase-line', label: 'B2B' },
    { icon: 'ri-store-2-line', label: 'B2C' },
    { icon: 'ri-settings-5-line', label: 'Производство' },
    { icon: 'ri-ship-line', label: 'Логистика' },
    { icon: 'ri-computer-line', label: 'IT' },
    { icon: 'ri-building-4-line', label: 'Недвижимость' },
    { icon: 'ri-service-line', label: 'Услуги' },
    { icon: 'ri-bank-line', label: 'Финансы' },
    { icon: 'ri-book-open-line', label: 'Образование' },
    { icon: 'ri-community-line', label: 'Строительство' },
    { icon: 'ri-heart-pulse-line', label: 'Медицина' },
    { icon: 'ri-more-line', label: 'и другие' }
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            С какими компаниями работаю
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Отраслевая специфика не проблема — она учитывается на этапе диагностики. Программа адаптируется под продукт, цикл продаж и бизнес-модель.
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4 max-w-5xl mx-auto">
          {industries.map((ind, i) => (
            <div key={i} className="bg-white rounded-xl p-4 md:p-5 text-center hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 cursor-default group">
              <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center mx-auto mb-3 group-hover:bg-teal-600 transition-colors duration-300">
                <i className={`${ind.icon} text-xl text-teal-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <span className="text-sm font-medium text-gray-700">{ind.label}</span>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/enciklopediya-korporativnogo-obucheniya"
            className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer text-sm"
          >
            Посмотреть все направления обучения
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}